<template>
    <div class="integrations">

        <div class="integrations__content">
            <router-view/>
        </div>

    </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">

    @import "~@astina/paloma-common-ui/src/css/theme";

    .integrations {
        display: flex;
        flex-direction: column;
    }

    .integrations__content {
        border-top: 1px solid $grey-2;
        background-color: $grey-0;
        flex: 1;
        min-height: 0;
        overflow: auto;
        display: flex;
        flex-direction: column;
    }

</style>